import { toRefs } from 'vue';
import Toggle from './component-lib.esm.js';
import VisibilityIcon from '../../icons/component-lib.esm24.js';
import VisibilityOffIcon from '../../icons/component-lib.esm41.js';
import { ToggleProps } from './component-lib.esm3.js';
import { useModel } from '../../compositions/component-lib.esm13.js';

//
var script = {
  components: {
    Toggle,
    VisibilityIcon,
    VisibilityOffIcon
  },
  props: ToggleProps,
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const checked = useModel(value, val => emit('input', val));
    return {
      checked
    };
  }
};
export { script as default };